export default __webpack_public_path__ + "static/media/logo@svg.5b7d2445.svg";